import { useMutation, useQuery } from '@tanstack/react-query';
import { AuthStateResponse, SessionStateResponse } from '@cloudsign/shared';
import { api } from '../../lib/api';
import { useAuthState } from '../../lib/authState';
import { t } from '../../lib/i18n';
import { ErrorLine } from '../../components/ErrorPanel';
import { Button } from '../../components/ui';
import { AuthLayout, useProceed } from './AuthLayout';

export function ChooseTenantPage() {
  const proceed = useProceed();
  const auth = useAuthState();
  const choose = useMutation({
    mutationFn: (body: { tenantId: string } | { platform: true }) =>
      api.post('/auth/select-tenant', { body, schema: AuthStateResponse }),
    onSuccess: proceed,
  });
  // Shared reception (ADR 0034): buildings this account is staff of are offered here too ("Building: <name>").
  const session = useQuery({
    queryKey: ['auth', 'session'],
    queryFn: () => api.get('/auth/session', { schema: SessionStateResponse, quiet401: true }),
    retry: false,
  });
  const chooseBuilding = useMutation({
    mutationFn: (buildingId: string) => api.post('/auth/select-building', { body: { buildingId }, schema: AuthStateResponse }),
    onSuccess: proceed,
  });
  const busy = choose.isPending || chooseBuilding.isPending;
  return (
    <AuthLayout title={t('auth.chooseTenant')}>
      <div className="space-y-3">
        <ErrorLine error={choose.error ?? chooseBuilding.error} />
        <ul className="space-y-2">
          {(auth?.tenants ?? []).map((tn) => (
            <li key={tn.tenantId}>
              <Button className="w-full justify-start" disabled={busy} onClick={() => choose.mutate({ tenantId: tn.tenantId })}>
                {tn.name}
              </Button>
            </li>
          ))}
          {(session.data?.buildings ?? []).map((b) => (
            <li key={b.buildingId}>
              <Button className="w-full justify-start" disabled={busy} onClick={() => chooseBuilding.mutate(b.buildingId)}>
                {t('srb.shell.building', { name: b.name })}
              </Button>
            </li>
          ))}
          {auth?.platformAdmin ? (
            <li>
              <Button variant="primary" className="w-full justify-start" disabled={busy} onClick={() => choose.mutate({ platform: true })}>
                {t('auth.platformArea')}
              </Button>
            </li>
          ) : null}
        </ul>
      </div>
    </AuthLayout>
  );
}
